angular.module('impactx.address').directive('appMultiAddressInput', function () {
    return {
        scope: {
            handoverAddress: '=',
            readonlyHandover: '=',
            contactAddress: '=',
            readonlyContact: '=',
            invoiceAddress: '=',
            readonlyInvoice: '=',
            deliveryAddress: '=',
            readonlyDelivery: '=',
            trns: '=',
            enableNew: '=',
            enableEdit: '=',
            enableInheritanceOptions: '=',
            enableReadOnlyButtons: '=',
            owningComOptions: '=',
            disableOwningCom: '=',
            saveDirect: '=',
            disableInput: '=',
            entryPoint: "@",
            personalData: "=",
            additionalDataForEntryPoint: "=",
            regionCodeDeliveryAddress: "="
        },
        controller: 'MultiAddressInputCtrl',
        controllerAs: 'ctrl',
        restrict: 'E',
        templateUrl: 'modules/address/templates/multi-address-input.tmpl.html'
    };
});
